import React from "react";
import {JSX} from "react/jsx-runtime";
import WysiwygLayoutView from "../content-blocks/WysiwygLayoutView";
import PostsLayoutView from "../content-blocks/PostsLayoutView";
import CustomLayoutView from "../content-blocks/CustomLayoutView";
import {IContentBlock} from "../../../ts/data/subject/PostDataHelper";

interface IProps
{
    blocks:IContentBlock[]
}

const ContentBlocksStructure = (props: IProps) =>
{

    const getLayout = (block:IContentBlock):JSX.Element|null => {
        switch (block.acfFcLayout)
        {
            case "wysiwyg_layout":
                return <WysiwygLayoutView {...block} />
            case "posts_layout":
                return <PostsLayoutView {...block} />
            case "custom_layout":
                return <CustomLayoutView {...block} />
            default:
                return null;
        }
    }

    return <>

        {(() =>
        {
            const sections: JSX.Element[] = [];
            let index = -1;
            for (let block of props.blocks)
            {
                index ++;

                let useLayout = block.acfFcLayout ?? "";
                let innerBG = "";
                if(useLayout === "full_size_image_layout" || useLayout === "gallery_layout"){
                    useLayout = 'multimedia_layout'
                }
                let blockColour = block.colour ? 'set-bg-' + block.colour : "";
                if(useLayout === "callout_layout" || useLayout === "current_campaign_layout"){
                    innerBG = blockColour
                    blockColour = ''
                    block = {
                        ...block,
                        innerBG: innerBG
                    }
                }
                const layout = getLayout(block);
                if(!layout){
                    continue;
                }


                sections.push(<section key={index} className={"content-block " + useLayout + " " + blockColour + " " + (block.marginAbove ?? "")  + " " + (block.marginBelow ?? "") + " " + (block.paddingAbove ?? "") + " " + (block.paddingBelow ?? "")  + " " + (block.alignment ?? "") + ""}>
                    {layout}
                </section>);
            }
            return sections;
        })()}
    </>
}
export default ContentBlocksStructure;